<template>
    <span
        class="input-view"
        @mouseenter="showClose = true"
        @mouseleave="showClose = false"
    >
        <input-wrapper ref="inputWrapper" v-if="showInput" :icon="getIcon()" @clear="handleClear"></input-wrapper>
        <tag-wrapper ref="tagWrapper" v-else :icon="getIcon()" @clear="handleClear"></tag-wrapper>
    </span>
</template>
<script>
import InputWrapper from './InputWrapper';
import TagWrapper from './TagWrapper';

export default {
    components: {
        InputWrapper,
        TagWrapper
    },
    inject: ['levelSelect'],
    data() {
        return {
            showClose: false
        };
    },
    computed: {
        showInput() {
            if (!this.levelSelect.showTags || !this.levelSelect.multiple) return true;
            return this.levelSelect.store.selectedValue.length <= 1;
        },
        closeVisible() {
            return (
                this.levelSelect.clearable &&
                !this.levelSelect.innerDisabled &&
                this.showClose &&
                this.levelSelect.store.selectedValue.filter(item => !item.disabled).length
            );
        }
    },
    methods: {
        getIcon() {
            if (this.closeVisible) {
                return 'el-icon-circle-close';
            }
            return this.levelSelect.popoverVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down';
        },
        handleClear() {
            if (this.closeVisible) {
                this.levelSelect.store.handleClear();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.input-view {
    display: inline-block;
}
</style>
